// @flow
import update from 'immutability-helper';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  endpoints,
  getUserWishListApi,
} from './api';
import { ofType } from 'redux-observable';

import type { Deal, WishList as WishListType } from '../../entities';
import type { HTTPError } from '../../error';

export type HomeAction = {
  +type: string;
  /*+email?: string;
  +language?: string;
  +country?: string;*/
  +nameSlug?: string;
  +userId?: string;
  +wishList?: WishListType;
  +error?: HTTPError;
};

export type HomeState = {
  /*isSubscribing?: boolean;
  subscribeSuccess?: boolean;
  error?: HTTPError;*/
  +isFetchingWishList?: boolean;
  +wishLists: { [key: string]: WishListType };
  +fetchWishListError?: HTTPError;
};

// Actions
const HOME_RESET_STATE = 'HOME_RESET_STATE';
/*const HOME_POST_SUBSCRIBE_REQUEST = 'HOME_POST_SUBSCRIBE_REQUEST';
const HOME_POST_SUBSCRIBE_SUCCESS = 'HOME_POST_SUBSCRIBE_SUCCESS';
const HOME_POST_SUBSCRIBE_ERROR = 'HOME_POST_SUBSCRIBE_ERROR';*/
const HOME_FETCH_WISH_LIST_REQUEST = 'HOME_FETCH_WISH_LIST_REQUEST';
const HOME_FETCH_WISH_LIST_SUCCESS = 'HOME_FETCH_WISH_LIST_SUCCESS';
const HOME_FETCH_WISH_LIST_ERROR = 'HOME_FETCH_WISH_LIST_ERROR';

// Action Creators
/*export function subscribe(email: string, language: string, country: string): HomeAction {
  return {
    type: HOME_POST_SUBSCRIBE_REQUEST,
    email,
    language,
    country,
  };
}

export function subscribeSuccessFn(): HomeAction {
  return {
    type: HOME_POST_SUBSCRIBE_SUCCESS,
  };
}

export function subscribeError(error: HTTPError): HomeAction {
  return {
    type: HOME_POST_SUBSCRIBE_ERROR,
    error,
  };
}*/
export function fetchWishList(nameSlug: string, userId: string): HomeAction {
  return {
    type: HOME_FETCH_WISH_LIST_REQUEST,
    nameSlug,
    userId,
  };
}

export function fetchWishListSuccess(wishList: WishListType): HomeAction {
  return {
    type: HOME_FETCH_WISH_LIST_SUCCESS,
    wishList,
  };
}

export function fetchWishListErrorFn(error: HTTPError): HomeAction {
  return {
    type: HOME_FETCH_WISH_LIST_ERROR,
    error,
  };
}

export function resetState(error: HTTPError): HomeAction {
  return {
    type: HOME_RESET_STATE,
    error,
  };
}

export const actions = {
  HOME_RESET_STATE,
  HOME_FETCH_WISH_LIST_REQUEST,
  HOME_FETCH_WISH_LIST_SUCCESS,
  HOME_FETCH_WISH_LIST_ERROR,
  fetchWishList,
  fetchWishListSuccess,
  fetchWishListErrorFn,
  /*HOME_POST_SUBSCRIBE_REQUEST,
  HOME_POST_SUBSCRIBE_SUCCESS,
  HOME_POST_SUBSCRIBE_ERROR,
  subscribe,
  subscribeSuccessFn,
  subscribeError,*/
  resetState,
};

export const initialState: HomeState = {
  wishLists: {},
};

// Reducer
export default function reducer(state: HomeState = initialState,
                                action: HomeAction): HomeState {
  switch (action.type) {
    /*case HOME_POST_SUBSCRIBE_REQUEST:
      return {
        isSubscribing: true,
      };
    case HOME_POST_SUBSCRIBE_SUCCESS:
      return {
        subscribeSuccess: true,
      };
    case HOME_POST_SUBSCRIBE_ERROR:
      return {
        error: action.error,
      };*/
    case HOME_FETCH_WISH_LIST_REQUEST:
      return update(state, {
        isFetchingWishList: { $set: true },
      });
    case HOME_FETCH_WISH_LIST_SUCCESS:
      if (!action.wishList) return state;
      return update(state, {
        wishLists: {
          [action.wishList.slug]: { $set: action.wishList },
          $unset: ['isFetchingWishList'],
        },
      });
    case HOME_FETCH_WISH_LIST_ERROR:
      if (!action.error) return state;
      return update(state, {
        fetchWishListError: { $set: action.error },
      });
    case HOME_RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export function fetchWishListEpic(action$: Observable<HomeAction>): Observable<HomeAction> {
  return action$.pipe(
    ofType(HOME_FETCH_WISH_LIST_REQUEST),
    mergeMap(({ nameSlug, userId }) => getUserWishListApi({
      sort: 'UPDATED_AT',
      order: 'DESC',
    }, {
      route: endpoints.GET_USER_WISH_LIST.replace(':nameSlug', nameSlug).replace(':userId', userId),
    }).pipe(
      map((wishList: WishListType) => fetchWishListSuccess(wishList)),
      catchError((e: HTTPError) => of(fetchWishListErrorFn(e))),
    )),
  );
}

/*export function subscribeEpic(action$: Observable<HomeAction>): Observable<HomeAction> {
  return action$.pipe(
    ofType(HOME_POST_SUBSCRIBE_REQUEST),
    mergeMap(({ email, language, country }) => subscribeApi({ email, language, country }).pipe(
      map(() => subscribeSuccessFn()),
      catchError((e: HTTPError) => of(subscribeError(e))))
    ));
}*/



// WEBPACK FOOTER //
// ./src/modules/home/duck.js